// src/module/api-cache/index.ts
var ApiCache = class {
  endpoints;
  opts;
  cache = /* @__PURE__ */ new Map();
  page = 0;
  _total = 0;
  get total() {
    return this._total;
  }
  constructor(endpoints, opts) {
    this.endpoints = endpoints;
    this.opts = {
      maxEntries: Infinity,
      pageLength: 50,
      timeBetweenRequests: 100,
      ...opts
    };
  }
  async _populate(params = {
    page: this.page,
    pageLength: this.opts.pageLength
  }) {
    if (!this.endpoints.list) {
      throw new Error("You need to implement the `endpoints.list` function in order to populate the cache.");
    }
    const { total, results } = await this.endpoints.list(params);
    this._total = total;
    results.forEach((entry) => {
      this.cache.set(entry.id, entry);
    });
    this.page++;
  }
  async populate() {
    this.reset();
    await this._populate();
    const cutoff = Math.min(this.opts.maxEntries, this._total);
    while (this.cache.size < cutoff) {
      await this._populate();
      await new Promise((r) => setTimeout(r, this.opts.timeBetweenRequests));
    }
  }
  reset() {
    this.cache = /* @__PURE__ */ new Map();
    this.page = 1;
    this._total = 0;
  }
  set(id, entry) {
    this.cache.set(id, entry);
  }
  async get(id) {
    const cached = this.cache.get(id);
    if (typeof cached !== "undefined") {
      return cached;
    }
    if (this.endpoints.get) {
      const retrieved = await this.endpoints.get(id);
      if (retrieved) {
        this.set(id, retrieved);
      }
      return retrieved;
    }
  }
  async search(query) {
    if (!this.endpoints.search) {
      return;
    }
    const retrieved = await this.endpoints.search(query);
    retrieved?.forEach((item) => {
      this.set(item.id, item);
    });
    return retrieved;
  }
  getEntries() {
    return Array.from(this.cache.values());
  }
  getIds() {
    return Array.from(this.cache.keys());
  }
  getFromCache(id) {
    return this.cache.get(id);
  }
  has(id) {
    return this.cache.has(id);
  }
  delete(id) {
    return this.cache.delete(id);
  }
};

export { ApiCache };
